import { render } from "./70_goodbye.vue?vue&type=template&id=6a0f9221"
import script from "./70_goodbye.vue?vue&type=script&lang=js"
export * from "./70_goodbye.vue?vue&type=script&lang=js"

import "./70_goodbye.vue?vue&type=style&index=0&id=6a0f9221&lang=css"
script.render = render

export default script